import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import MobileHeaderOnly from "components/headers/light.js";
import Hero from "salad/Hero.js";
import TwoColumn from "salad/TwoColumn";
import Footer from "salad/GrainFooter.js";
import Showcase from "salad/PromoShowcase.js";
import AppDownloadPromo from "salad/DownLoadApp";


export default () => (
    <div style={{ backgroundColor: "#FFFBDC", minHeight: "100vh" }}>
        <MobileHeaderOnly />
        <AnimationRevealPage>
            <Hero />
            <Showcase />
            <AppDownloadPromo />
            <TwoColumn />

            <Footer />

        </AnimationRevealPage>
    </div>
);
